import { errorMessage, fetchCustom, formSubmit, MessageDictionary } from './util'
import moment from 'moment'

const urlSearchParams = new URLSearchParams(window.location.search)
const packageId = Number(urlSearchParams.get('packageId'))
const paymentId = Number(urlSearchParams.get('paymentId'))

const registerSubmit = async (event) => {
    const { button, buttonText } = formSubmit(event)

    const birthdate = moment(event.target.elements.birthdate.value, 'DD/MM/YYYY').format('YYYY-MM-DD')
    const couponId = $('#coupon-form')?.data('coupon-id')
    const cpf = event.target.elements.cpf.value
    const email = event.target.elements.email.value
    const name = event.target.elements.name.value
    const password = event.target.elements.password.value
    const passwordConfirm = event.target.elements['password-confirm'].value
    const phone = event.target.elements.phone.value

    if (passwordConfirm !== password) return errorMessage(MessageDictionary.INVALID_PASSWORD)

    const response = await fetchCustom(`${process.env.MIX_PROD_BASE_URL}/payment/register`, {
        method: 'POST',
        body: {
            birthdate,
            cpf,
            email,
            name,
            packageId,
            password,
            phone,
            ...(couponId && { couponId }),
            ...(paymentId && { paymentId }),
        },
    }, MessageDictionary.TRY_AGAIN).catch(errorMessage)

    if (response && response.paymentId) {
        window.localStorage.setItem('redacao-data', JSON.stringify(response.user))

        fbq('track', 'Lead')

        urlSearchParams.delete('paymentId')
        window.location = `/checkout/payment/${response.paymentId}?${urlSearchParams.toString()}`
    }

    button.removeAttribute('disabled')
    button.innerHTML = buttonText
}

const loginSubmit = async (event) => {
    const { button, buttonText } = formSubmit(event)

    const couponId = $('#coupon-form')?.data('coupon-id')
    const email = event.target.elements.email.value
    const password = event.target.elements.password.value

    const response = await fetchCustom(`${process.env.MIX_PROD_BASE_URL}/payment/auth`, {
        method: 'POST',
        body: {
            email,
            packageId,
            password,
            ...(couponId && { couponId }),
            ...(paymentId && { paymentId }),
        },
    }, MessageDictionary.INVALID_LOGIN).catch(errorMessage)

    if (response && response.paymentId) {
        window.localStorage.setItem('redacao-data', JSON.stringify(response.user))

        urlSearchParams.delete('paymentId')
        window.location = `/checkout/payment/${response.paymentId}?${urlSearchParams.toString()}`
    }

    button.removeAttribute('disabled')
    button.innerHTML = buttonText
}

$('#register-form input[name="email"]').blur(async (event) => {
    const regex = /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/

    if (regex.test(event.target.value)) {
        await fetchCustom(
            `${process.env.MIX_PROD_BASE_URL}/payment/email`,
            { method: 'POST', body: { email: event.target.value } },
            MessageDictionary.DUPLICATED_EMAIL,
        ).catch((error) => {
            event.target.value = ''
            errorMessage(error)
        })
    } else {
        event.target.value = ''
        errorMessage(MessageDictionary.INVALID_EMAIL)
    }
})

$(document).ready(function () {
    $('#register-form').on('submit', registerSubmit)
    $('#login-form').on('submit', loginSubmit)
})
